<div class="qty">
    <button type="button" class="btn qtyBtn" (click)="remove()">-</button>
    <input type="number" class="qtyObj" min="0" max="99" readonly [(ngModel)]="value"/>
    <button type="button" class="btn qtyBtn" (click)="add()">+</button>
</div>